var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boolean-control"},[_c('b-form-checkbox',{class:{ 'field-error': this.$v.value.$error },attrs:{"switch":"","size":_vm.size ? _vm.size : 'lg'},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(" "+_vm._s(_vm.data.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }